module.exports = __webpack_public_path__ + "img/H-63-ER-1500-GA.fd29cc64.png";